import React, { useEffect } from "react";
import { setRandomBackground } from "../helpers/backgroundHelpers";

const Contact: React.FC = () => {
  useEffect(() => {
    setRandomBackground();
  }, []);

  return (
    <div
      style={{
        padding: "2rem 1.25rem 4rem",
        maxWidth: 900,
        margin: "0 auto",
        color: "#fff",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
        lineHeight: 1.45,
      }}
    >
      <header style={{ marginBottom: "2rem" }}>
        <h1 style={{ margin: 0, fontSize: "2.4rem", letterSpacing: "0.5px" }}>
          Contact
        </h1>
        <p style={{ opacity: 0.8, margin: "0.5rem 0 0" }}>
          I'd love to hear from you. Feel free to reach out directly or use the
          form below.
        </p>
      </header>

      <section
        style={{
          background: "rgba(255,255,255,0.05)",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: 12,
          padding: "1.25rem 1.4rem 1.5rem",
          backdropFilter: "blur(4px)",
          marginBottom: "2.5rem",
        }}
        aria-labelledby="direct-contact-heading"
      >
        <h2
          id="direct-contact-heading"
          style={{ margin: 0, fontSize: "1.4rem" }}
        >
          Direct
        </h2>
        <p style={{ marginTop: "0.85rem", opacity: 0.85 }}>
          Email:{" "}
          <a href="mailto:robyn@robynseverson.com">robyn@robynseverson.com</a>
          <br /> LinkedIn:{" "}
          <a
            href="https://www.linkedin.com/in/robyn-severson/"
            target="_blank"
            rel="noopener noreferrer"
          >
            linkedin.com/in/robyn-severson
          </a>
        </p>
      </section>
    </div>
  );
};

export default Contact;
